import { Banner, spacing, Text } from "@minuthq/meatball-ui-react"

import { useDeleteParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { Routes } from "src/router/routes"
import { useRouter } from "src/router/useRouter"
import { ConfirmDialog } from "src/ui/Dialog/ConfirmDialog"

export function ParadiseDeleteLLMPromptDialog({
  onClose,
  promptId,
}: {
  onClose: () => void
  promptId: string
}) {
  const { navigate } = useRouter()

  const deleteParadiseLLMPrompt = useDeleteParadiseLLMPrompt()

  async function deleteLLMPrompt() {
    deleteParadiseLLMPrompt.mutate(
      {
        path: { prompt_id: promptId },
      },
      {
        onSuccess: () => {
          navigate(Routes.ParadiseLLMPrompts.location(), {
            replace: true,
          })
          onClose()
        },
      }
    )
  }

  return (
    <ConfirmDialog
      open={true}
      onClose={onClose}
      title="Delete LLM Prompt"
      confirmLabel="Delete"
      onConfirm={deleteLLMPrompt}
      loading={deleteParadiseLLMPrompt.isPending}
      confirmButtonProps={{
        color: "destructive",
      }}
    >
      <Text variant="subtitle" marginBottom={spacing.M}>
        Are you sure you want to delete this LLM prompt?
      </Text>

      <Banner type="warning" fullWidth>
        This action cannot be undone and will remove all versions of the prompt.
      </Banner>
    </ConfirmDialog>
  )
}
